import { Flex, Text, Anchor } from '@mantine/core';

interface Props {
	label: string;
	value: string;
	onViewInDocument?: (e?: React.MouseEvent) => void;
	viewInDocumentLabel?: string;
}

export const DetailField = ({ label, value, onViewInDocument, viewInDocumentLabel }: Props) => (
	<Flex direction="column" gap={2}>
		<Text size="xs" color="dimmed">
			{label}
		</Text>
		<Flex align="center" gap={4}>
			<Text size="sm">{value}</Text>
			{onViewInDocument && (
				<Anchor size="xs" component="button" color="dimmed" onClick={onViewInDocument}>
					{viewInDocumentLabel}
				</Anchor>
			)}
		</Flex>
	</Flex>
);
